import type { CasaLeonOperationalEvent, CasaLeonWorldSnapshot } from '@casa-leon-vivo/contracts/casa-leon';
import { clearDemoJournal, loadDemoJournal, saveDemoJournal } from './demo-persistence.js';
import { rebuildFromEvents } from './world-reducer.js';
import { MundoVivoSession } from './mundo-vivo-session.js';

/** Sesi�n demo con journal persistido (Orden 015). */
export class DemoIntegralSession {
  private inner = new MundoVivoSession();
  private journal: CasaLeonOperationalEvent[] = [];

  constructor(hydrate = true) {
    if (hydrate) this.loadFromStorage();
  }

  getJournal(): CasaLeonOperationalEvent[] {
    return [...this.journal];
  }

  getSnapshot(): CasaLeonWorldSnapshot {
    return this.inner.getSnapshot();
  }

  apply(event: CasaLeonOperationalEvent): CasaLeonWorldSnapshot {
    const before = this.inner.getSnapshot().appliedEventIds.length;
    const snap = this.inner.apply(event);
    if (snap.appliedEventIds.length > before) {
      this.journal.push(event);
      saveDemoJournal(this.journal);
    }
    return snap;
  }

  applyMany(events: CasaLeonOperationalEvent[]): CasaLeonWorldSnapshot {
    let snap = this.inner.getSnapshot();
    for (const e of events) {
      snap = this.apply(e);
    }
    return snap;
  }

  reset(): CasaLeonWorldSnapshot {
    this.journal = [];
    clearDemoJournal();
    return this.inner.reset();
  }

  loadFromStorage(): boolean {
    const loaded = loadDemoJournal();
    if (!loaded?.length) return false;
    this.journal = loaded;
    this.inner.rebuild(loaded);
    return true;
  }

  replayIntegrity(): boolean {
    const rebuilt = rebuildFromEvents(this.journal);
    return rebuilt.revision === this.inner.getSnapshot().revision;
  }
}
